import { Dialog } from "primereact/dialog";
import { IContact } from "../../models/BaseModel";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

const schema = yup.object({});

interface Iprops {
    singleData: IContact;
    open: boolean;
    hideDialog: () => void;
    toast: any;
    reloadData: () => void;
    hasPermission: (pageName: string, featureName?: string) => boolean;
}

export const CallHistory = (props: Iprops) => {

    const [tableData, setTableData] = useState({
        data: [],
        count: 0,
        loading: false
    } as { data: IContact[]; count: number; loading: boolean });

    const [audioUrl, setAudioUrl] = useState<string | null>(null);
    const [showPlayer, setShowPlayer] = useState(false);

    const onHide = () => {
        props.hideDialog();
    };

    const loadTableData = async () => {
        setTableData(prev => ({ ...prev, loading: true }));

        const response = await Fetch(
            "IVR/getCallHistory",
            "GET",
            null,
            `ContactId=${props.singleData.id}`,
            props.toast
        );

        if (response) {
            const data: { contacts: IContact[]; count: number } =
                await response.json();

            setTableData({
                data: data.contacts,
                count: data.count,
                loading: false
            });
        } else {
            setTableData(prev => ({ ...prev, loading: false }));
        }
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    // PLAY BUTTON
    const LiveCallRecording = (rowData: any) => {

        const handlePlay = async () => {
            try {
                const response = await fetch(
                    `${baseUrl}IVR/DownloadWav?fileUrl=${encodeURIComponent(
                        rowData.recordingUrl
                    )}`
                );

                if (!response.ok) {
                    props.toast.current.show({
                        severity: "error",
                        detail: "Unable to load recording"
                    });
                    return;
                }

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);

                setAudioUrl(url);
                setShowPlayer(true);

            } catch (err) {
                console.error(err);
                props.toast.current.show({
                    severity: "error",
                    detail: "Error playing recording"
                });
            }
        };

        return (
            <Button
                icon="pi pi-play"
                className="p-button-rounded p-button-text p-button-success"
                onClick={handlePlay}
            />
        );
    };

    return (
        <>
            {/* Main History Dialog */}
            <Dialog
                visible={props.open}
                style={{ width: "400px" }}
                header="Call History"
                modal
                className="p-fluid"
                onHide={onHide}
            >
                <DataTable
                    style={{
                        border: "1px solid rgba(105,105,105,0.17)",
                        borderTopWidth: "0"
                    }}
                    size="small"
                    stripedRows
                    scrollable
                    scrollHeight="75vh"
                    exportFilename={format(
                        new Date(),
                        "dd-MM-yyyy hh_mm_ss a"
                    ).toUpperCase()}
                    value={tableData.data}
                    lazy
                    dataKey="id"
                    header="Call History"
                    loading={tableData.loading}
                >
                    <Column
                        field="customerNumber"
                        header="Customer Number"
                        sortable
                    />
                    <Column
                        field="agentNumber"
                        header="Agent Number"
                        sortable
                    />
                    <Column field="duration" header="Duration" sortable />
                    <Column
                        field="callDirection"
                        header="Call Status"
                        sortable
                    />
                    <Column
                        header="Play"
                        body={LiveCallRecording}
                        style={{ width: "60px" }}
                    />
                </DataTable>
            </Dialog>

            {/* Audio Player Dialog */}
            <Dialog
                visible={showPlayer}
                header="Call Recording"
                style={{ width: "450px" }}
                modal
                onHide={() => setShowPlayer(false)}
            >
                <audio controls autoPlay style={{ width: "100%" }}>
                    <source src={audioUrl!} type="audio/wav" />
                    <source src={audioUrl!} type="audio/mp3" />
                    Your browser does not support audio playback.
                </audio>

                <Button
                    label="Close"
                    className="p-button-text p-button-danger mt-3"
                    onClick={() => setShowPlayer(false)}
                />
            </Dialog>
        </>
    );
};
